export { default } from './DeliveryContact.container';
export { default as DeliveryContact } from './DeliveryContact';
